import Exerciseimg3 from '@assets/images/exercise-library/exercise3.png';
import i18n from '@/i18n';
import 'twin.macro';
import { APP_CONFIG } from '@/constants/config';

export const USER_TYPES = {
  PATIENT: 'patient',
  THERAPIST: 'therapist',
  DASHBOARD: 'dashboard',
  CLINIC_OWNER: 'clinicOwner',
  MEDICAL_DIRECTOR: 'medicalDirector',
  RECEPTIONIST: 'receptionist',
};
// User type configuration
export const USER_TYPE = APP_CONFIG.USER_TYPE || USER_TYPES.THERAPIST; // Can be 'therapist' or 'patient'

export const screenSizes = {
  sm_custom: 600,
  sm: 640,
  md: 768,
  md_custom: 900,
  lg: 1024,
  xl: 1280,
  custom_xl: 1440,
  '2xl': 1536,
  '3xl': 1706,
  '4xl': 1920,
  '6xl': 2400,
};

export const getGenderOptions = t => [
  { value: 'MALE', label: t('options.gender.male') },
  { value: 'FEMALE', label: t('options.gender.female') },
];

export const getLanguageOptions = t => [
  { value: 'EN', label: t('options.language.en') },
  { value: 'AR', label: t('options.language.ar') },
];

/** Build at render time so `t` uses the active language (module-level i18n.t() was frozen at load). */
export const getHeightUnitOptions = t => [
  { value: 'CM', label: t('options.height.cm') },
  { value: 'M', label: t('options.height.m') },
  { value: 'IN', label: t('options.height.in') },
  { value: 'FT', label: t('options.height.ft') },
];

export const getWeightUnitOptions = t => [
  { value: 'KG', label: t('options.weight.kg') },
  { value: 'G', label: t('options.weight.g') },
  { value: 'LB', label: t('options.weight.lb') },
];

export const dayPerformanceStatus = {
  MISSED: 'missed',
  INCOMPLETE: 'incomplete',
  COMPLETE: 'completed',
};

export const prescriptionMode = {
  TEMPLATE: 'template',
  PRESCRIPTION: 'prescription',
  EDIT: 'edit',
};

/** Prescription status from API (uppercase). Normalized to lowercase in mapApiPrescriptionToView. */
export const PRESCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  UPCOMING: 'UPCOMING',
  // Stopped by a discharge / deactivation; never active again, and read-only
  // (PUT /prescriptions/:id 409s).
  TERMINATED: 'TERMINATED',
};

/** Completed or Terminated - the prescription can no longer be edited. */
export const isEndedPrescriptionStatus = status =>
  [PRESCRIPTION_STATUS.COMPLETED, PRESCRIPTION_STATUS.TERMINATED].includes(
    String(status || '').toUpperCase()
  );

export const patietReorderableColumns = [
  i18n.t('glossary.status', { ns: 'common' }),
  i18n.t('glossary.prescription', { ns: 'common', count: 1 }),
  i18n.t('main.patient_tabel.coulmns_name.overall_adherence', { ns: 'patients' }),
  i18n.t('main.patient_tabel.coulmns_name.adherence', { ns: 'patients' }),
  i18n.t('common.label.pain_level', { ns: 'patients' }),
  i18n.t('main.patient_tabel.coulmns_name.assigned_pt', { ns: 'patients' }),
  i18n.t('label.email_address', { ns: 'common' }),
  i18n.t('glossary.date_joined', { ns: 'common' }),
  i18n.t('main.patient_tabel.coulmns_name.last_visit', { ns: 'patients' }),
  i18n.t('main.patient_tabel.coulmns_name.overall_period', { ns: 'patients' }),
  i18n.t('main.patient_tabel.coulmns_name.time_left', { ns: 'patients' }),
  i18n.t('main.patient_tabel.coulmns_name.expiration_date', { ns: 'patients' }),
];

export const staffReorderableColumns = [
  { label: i18n.t('label.email_address', { ns: 'common' }), accessorKey: 'email' },
  { label: i18n.t('glossary.status', { ns: 'common' }), accessorKey: 'status' },
  { label: i18n.t('glossary.role', { ns: 'common' }), accessorKey: 'roles' },
  {
    label: i18n.t('main.staff_tabel.coulmns_name.num_of_patients', { ns: 'staff' }),
    accessorKey: 'numberOfPatients',
  },
  { label: i18n.t('glossary.date_joined', { ns: 'common' }), accessorKey: 'dateJoined' },
  {
    label: i18n.t('profile_tab.label.last_activity', { ns: 'common' }),
    accessorKey: 'lastActivity',
  },
];

export const STAFF_TABLE_ENUM = {
  email: i18n.t('label.email_address', { ns: 'common' }),
  status: i18n.t('glossary.status', { ns: 'common' }),
  roles: i18n.t('glossary.role', { ns: 'common' }),
  numberOfPatients: i18n.t('main.staff_tabel.coulmns_name.num_of_patients', { ns: 'staff' }),
  dateJoined: i18n.t('glossary.date_joined', { ns: 'common' }),
  lastActivity: i18n.t('profile_tab.label.last_activity', { ns: 'common' }),
};
export const PATIENTS_TABLE_ENUM = {
  dateOfBirth: i18n.t('main.patient_tabel.coulmns_name.age', { ns: 'patients' }),
  adherence: i18n.t('main.patient_tabel.coulmns_name.adherence', { ns: 'patients' }),
  prescription: i18n.t('main.patient_tabel.coulmns_name.prescription', { ns: 'patients' }),
  painLevel: i18n.t('common.label.pain_level', { ns: 'patients' }),
  lastSession: i18n.t('main.patient_tabel.coulmns_name.last_session', { ns: 'patients' }),
  expirationDate: i18n.t('main.patient_tabel.coulmns_name.expiration_date', { ns: 'patients' }),
};
export const contacts = (t, clinicName) => [
  {
    value: 'technicalSupport',
    label: t('contact_form.select_contact_option_one', { ns: 'common' }),
  },
  {
    value: 'clinic',
    label: clinicName || t('contact_form.select_contact_option_two', { ns: 'common' }),
  },
];

export const contentCar = [
  {
    id: 0,
    title: 'Arm Circles',
    movementName: 'arm_circles',
    isFavorite: true,
    imgUrl: Exerciseimg3,
    videoUrl:
      'https://videocdn.cdnpk.net/videos/af92c376-7164-4c19-be8d-8ab222fa9beb/horizontal/previews/watermarked/small.mp4',
    reps: 10,
    eta: 3,
    sets: 4,
    type: 'counting',
    singleRep: false,
    holdPerRep: true,
    basedOnRep: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 5,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 2,
        name: 'hold_duration',
        label: 'Hold duration',
        type: 'input',
        input_type: 'number',
        default: 30,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],

    basedOnTime: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 5,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'set_duration',
        label: 'Set duration',
        type: 'input',
        input_type: 'number',
        default: 9,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
      {
        id: 2,
        name: 'hold_duration',
        label: 'Hold duration',
        type: 'input',
        input_type: 'number',
        default: 31,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],
    exerciseConfig: [
      {
        id: 2,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 4,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 3,
          error_message: 'Sets count must be between 1 and 3.',
        },
      },
    ],
  },
  {
    id: 1,
    title: 'Cat Cow Strech',
    isFavorite: false,
    movementName: 'cat_cow_strech',
    imgUrl: Exerciseimg3,
    sets: 4,
    reps: 10,
    eta: 8,
    type: 'counting',
    videoUrl:
      'https://videocdn.cdnpk.net/videos/653caf65-0e8e-4941-b3d9-798a28ecfe6a/horizontal/previews/clear/small.mp4?token=exp=1750231577~hmac=120e287183a1ff237634fd6f7960264e6e3bb9c750bf04c0c37194009a4b49e8',
    singleRep: false,
    holdPerRep: false,
    basedOnRep: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 5,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
    ],

    basedOnTime: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 5,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'set_duration',
        label: 'Set duration',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],
    exerciseConfig: [
      {
        id: 4,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 3,
          error_message: 'Sets count must be between 1 and 3.',
        },
      },
    ],
  },
  {
    id: 2,
    movementName: 'ankle_circles',
    title: 'Ankle Circles',
    isFavorite: false,
    type: 'counting',
    imgUrl: Exerciseimg3,
    reps: 10,
    sets: 4,
    eta: 5,
    videoUrl:
      'https://videocdn.cdnpk.net/videos/72d0d679-cb78-4bf7-8fa1-ffbbbb06764c/horizontal/previews/clear/small.mp4?token=exp=1750231577~hmac=d0db94af97427f46e519ca9a3810281b073eadf5967b6b940d7c0af38b87f510',
    singleRep: true,
    holdPerRep: true,
    singleRepConfig: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'hold_duration',
        label: 'Hold duration',
        type: 'input',
        input_type: 'number',
        default: 31,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],
    exerciseConfig: [
      // {
      //   id: 1,
      //   name: 'mode',
      //   label: 'Sides',
      //   type: 'dropdown',
      //   options: ['Right side', 'Left side', 'Both side'],
      //   default: 'Left side',
      //   validation: {
      //     required: true,
      //     type: 'string',
      //     allowed_values: ['Right side', 'Left side', 'Both side'],
      //     error_message: 'Please select a valid side.',
      //   },
      // },
      {
        id: 2,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 7,
        name: 'holding-time',
        label: 'Holding time',
        type: 'input',
        input_type: 'number',
        default: 3,
        validation: {
          required: true,
          type: 'number',
          min: 3,
          max: 15,
          error_message: 'Holding time must be between 3 and 15 seconds.',
        },
      },
      {
        id: 4,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 3,
          error_message: 'Sets count must be between 1 and 3.',
        },
      },
    ],
  },
  {
    id: 3,
    title: 'Arm Pendulum Exercise',
    isFavorite: true,
    movementName: 'arm_pendulum_exercise',
    imgUrl: Exerciseimg3,
    sets: 4,
    reps: 10,
    eta: 8,
    type: 'counting',
    videoUrl:
      'https://videocdn.cdnpk.net/videos/653caf65-0e8e-4941-b3d9-798a28ecfe6a/horizontal/previews/clear/small.mp4?token=exp=1750231577~hmac=120e287183a1ff237634fd6f7960264e6e3bb9c750bf04c0c37194009a4b49e8',
    singleRep: false,
    holdPerRep: true,
    basedOnRep: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 2,
        name: 'hold_duration',
        label: 'Hold duration',
        type: 'input',
        input_type: 'number',
        default: 31,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],

    basedOnTime: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'set_duration',
        label: 'Set duration',
        type: 'input',
        input_type: 'number',
        default: 9,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
      {
        id: 2,
        name: 'hold_duration',
        label: 'Hold duration',
        type: 'input',
        input_type: 'number',
        default: 31,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],
    exerciseConfig: [
      // {
      //   id: 1,
      //   name: 'mode',
      //   label: 'Sides',
      //   type: 'dropdown',
      //   options: ['Right side', 'Left side', 'Both side'],
      //   default: 'Left side',
      //   validation: {
      //     required: true,
      //     type: 'string',
      //     allowed_values: ['Right side', 'Left side', 'Both side'],
      //     error_message: 'Please select a valid side.',
      //   },
      // },
      {
        id: 2,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 6,
        name: 'time',
        label: 'Time',
        type: 'input',
        input_type: 'number',
        default: 3,
        validation: {
          required: true,
          type: 'number',
          min: 3,
          max: 300,
          error_message: 'Time must be between 3 and 300 seconds.',
        },
      },
      {
        id: 4,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 3,
          error_message: 'Sets count must be between 1 and 3.',
        },
      },
    ],
  },
  {
    id: 4,
    title: 'Doorway Stretch',
    isFavorite: false,
    movementName: 'doorway_stretch',
    imgUrl: Exerciseimg3,
    sets: 4,
    reps: 10,
    eta: 8,
    type: 'counting',
    videoUrl:
      'https://videocdn.cdnpk.net/videos/653caf65-0e8e-4941-b3d9-798a28ecfe6a/horizontal/previews/clear/small.mp4?token=exp=1750231577~hmac=120e287183a1ff237634fd6f7960264e6e3bb9c750bf04c0c37194009a4b49e8',
    singleRep: false,
    holdPerRep: false,
    basedOnRep: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
    ],

    basedOnTime: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'set_duration',
        label: 'Set duration',
        type: 'input',
        input_type: 'number',
        default: 9,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],
    exerciseConfig: [
      // {
      //   id: 1,
      //   name: 'mode',
      //   label: 'Sides',
      //   type: 'dropdown',
      //   options: ['Right side', 'Left side', 'Both side'],
      //   default: 'Left side',
      //   validation: {
      //     required: true,
      //     type: 'string',
      //     allowed_values: ['Right side', 'Left side', 'Both side'],
      //     error_message: 'Please select a valid side.',
      //   },
      // },
      {
        id: 2,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 6,
        name: 'time',
        label: 'Time',
        type: 'input',
        input_type: 'number',
        default: 3,
        validation: {
          required: true,
          type: 'number',
          min: 3,
          max: 300,
          error_message: 'Time must be between 3 and 300 seconds.',
        },
      },
      {
        id: 4,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 3,
          error_message: 'Sets count must be between 1 and 3.',
        },
      },
    ],
  },
  {
    id: 5,
    title: 'Chair Cat-Cow Pose',
    isFavorite: true,
    movementName: 'chair_cat_cow_pose',
    imgUrl: Exerciseimg3,
    sets: 4,
    reps: 10,
    eta: 8,
    type: 'counting',
    videoUrl:
      'https://videocdn.cdnpk.net/videos/653caf65-0e8e-4941-b3d9-798a28ecfe6a/horizontal/previews/clear/small.mp4?token=exp=1750231577~hmac=120e287183a1ff237634fd6f7960264e6e3bb9c750bf04c0c37194009a4b49e8',
    singleRep: true,
    holdPerRep: true,
    singleRepConfig: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'hold_duration',
        label: 'Hold duration',
        type: 'input',
        input_type: 'number',
        default: 31,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],
    exerciseConfig: [
      // {
      //   id: 1,
      //   name: 'mode',
      //   label: 'Sides',
      //   type: 'dropdown',
      //   options: ['Right side', 'Left side', 'Both side'],
      //   default: 'Left side',
      //   validation: {
      //     required: true,
      //     type: 'string',
      //     allowed_values: ['Right side', 'Left side', 'Both side'],
      //     error_message: 'Please select a valid side.',
      //   },
      // },
      {
        id: 2,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 6,
        name: 'time',
        label: 'Time',
        type: 'input',
        input_type: 'number',
        default: 3,
        validation: {
          required: true,
          type: 'number',
          min: 3,
          max: 300,
          error_message: 'Time must be between 3 and 300 seconds.',
        },
      },
      {
        id: 4,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 3,
          error_message: 'Sets count must be between 1 and 3.',
        },
      },
    ],
  },
  {
    id: 6,
    title: 'Kittle bell Arm Windmills',
    isFavorite: false,
    movementName: 'kittle_bell_arm_windmills',
    imgUrl: Exerciseimg3,
    sets: 4,
    reps: 10,
    eta: 8,
    type: 'counting',
    videoUrl:
      'https://videocdn.cdnpk.net/videos/653caf65-0e8e-4941-b3d9-798a28ecfe6a/horizontal/previews/clear/small.mp4?token=exp=1750231577~hmac=120e287183a1ff237634fd6f7960264e6e3bb9c750bf04c0c37194009a4b49e8',
    singleRep: false,
    holdPerRep: true,
    basedOnRep: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 2,
        name: 'hold_duration',
        label: 'Hold duration',
        type: 'input',
        input_type: 'number',
        default: 31,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],

    basedOnTime: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'set_duration',
        label: 'Set duration',
        type: 'input',
        input_type: 'number',
        default: 9,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 2,
        name: 'hold_duration',
        label: 'Hold duration',
        type: 'input',
        input_type: 'number',
        default: 31,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],
    exerciseConfig: [
      // {
      //   id: 1,
      //   name: 'mode',
      //   label: 'Sides',
      //   type: 'dropdown',
      //   options: ['Right side', 'Left side', 'Both side'],
      //   default: 'Left side',
      //   validation: {
      //     required: true,
      //     type: 'string',
      //     allowed_values: ['Right side', 'Left side', 'Both side'],
      //     error_message: 'Please select a valid side.',
      //   },
      // },
      {
        id: 2,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 6,
        name: 'time',
        label: 'Time',
        type: 'input',
        input_type: 'number',
        default: 3,
        validation: {
          required: true,
          type: 'number',
          min: 3,
          max: 300,
          error_message: 'Time must be between 3 and 300 seconds.',
        },
      },
      {
        id: 4,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 3,
          error_message: 'Sets count must be between 1 and 3.',
        },
      },
    ],
  },
  {
    id: 7,
    title: 'Knee-To-Chest Stretch',
    isFavorite: false,
    movementName: 'knee_to_chest_stretch',
    imgUrl: Exerciseimg3,
    sets: 4,
    reps: 10,
    eta: 8,
    type: 'counting',
    videoUrl:
      'https://videocdn.cdnpk.net/videos/653caf65-0e8e-4941-b3d9-798a28ecfe6a/horizontal/previews/clear/small.mp4?token=exp=1750231577~hmac=120e287183a1ff237634fd6f7960264e6e3bb9c750bf04c0c37194009a4b49e8',
    singleRep: false,
    holdPerRep: false,
    basedOnRep: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
    ],

    basedOnTime: [
      {
        id: 0,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Sets count must be between 1 and 20.',
        },
      },
      {
        id: 1,
        name: 'set_duration',
        label: 'Set duration',
        type: 'input',
        input_type: 'number',
        default: 9,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 120,
          error_message: 'Reps must be between 1 and 120.',
        },
      },
    ],
    exerciseConfig: [
      // {
      //   id: 1,
      //   name: 'mode',
      //   label: 'Sides',
      //   type: 'dropdown',
      //   options: ['Right side', 'Left side', 'Both side'],
      //   default: 'Left side',
      //   validation: {
      //     required: true,
      //     type: 'string',
      //     allowed_values: ['Right side', 'Left side', 'Both side'],
      //     error_message: 'Please select a valid side.',
      //   },
      // },
      {
        id: 2,
        name: 'reps_count',
        label: 'Reps',
        type: 'input',
        input_type: 'number',
        default: 10,
        display_depends_on: {
          field: 'mode',
          values: ['Fixed Reps', 'Fixed Reps and Fixed Time'],
        },
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 20,
          error_message: 'Reps must be between 1 and 20.',
        },
      },
      {
        id: 6,
        name: 'time',
        label: 'Time',
        type: 'input',
        input_type: 'number',
        default: 3,
        validation: {
          required: true,
          type: 'number',
          min: 3,
          max: 300,
          error_message: 'Time must be between 3 and 300 seconds.',
        },
      },
      {
        id: 4,
        name: 'sets_count',
        label: 'Sets',
        type: 'input',
        input_type: 'number',
        placeholder: 'Enter number of sets',
        default: 4,
        validation: {
          required: true,
          type: 'number',
          min: 1,
          max: 3,
          error_message: 'Sets count must be between 1 and 3.',
        },
      },
    ],
  },
];

// List of path IDs to color
export const PATH_IDS = [
  { id: 'left_foot', color: '#8DA12B' },
  { id: 'right_foot', color: '#6A7920' },
  { id: 'left_ankle', color: '#C0D45E' },
  { id: 'right_ankle', color: '#C6D86E' },
  { id: 'right_leg', color: '#475016' },
  { id: 'left_leg', color: '' },
  { id: 'right_thigh', color: '' },
  { id: 'left_thigh', color: '' },
  { id: 'left_knee', color: '' },
  { id: 'left_hip', color: '' },
  { id: 'right_hand', color: '#6A7920' },
  { id: 'left_hand', color: '' },
  { id: 'right_wrist', color: '' },
  { id: 'left_wrist', color: '' },
  { id: 'left_arm', color: '#C0D45E' },
  { id: 'right_forearm', color: '' },
  { id: 'left_forearm', color: '' },
  { id: 'left_elbow', color: '#6A7920' },
  { id: 'stomach', color: '' },
  { id: 'back', color: '' },
  { id: 'chest', color: '' },
  { id: 'left_shoulder', color: '' },
  { id: 'right_shoulder', color: '#6A7920' },
  { id: 'neck', color: '' },
  { id: 'header', color: '' },
];

export const PATH_IDS_2 = [
  { id: 'left_foot', color: '' },
  { id: 'right_foot', color: '' },
  { id: 'left_ankle', color: '' },
  { id: 'right_ankle', color: '#C6D86E' },
  { id: 'right_leg', color: '' },
  { id: 'left_leg', color: '' },
  { id: 'right_thigh', color: '' },
  { id: 'left_thigh', color: '#6A7920' },
  { id: 'left_knee', color: '' },
  { id: 'left_hip', color: '' },
  { id: 'right_hand', color: '#6A7920' },
  { id: 'left_hand', color: '' },
  { id: 'right_wrist', color: '#6A7920' },
  { id: 'left_wrist', color: '' },
  { id: 'left_arm', color: '#C0D45E' },
  { id: 'right_forearm', color: '' },
  { id: 'left_forearm', color: '#8DA12B' },
  { id: 'left_elbow', color: '' },
  { id: 'stomach', color: '#475016' },
  { id: 'back', color: '' },
  { id: 'chest', color: '#C0D45E' },
  { id: 'left_shoulder', color: '' },
  { id: 'right_shoulder', color: '#6A7920' },
  { id: 'neck', color: '#6A7920' },
  { id: 'header', color: '' },
];

export const templateExample = [
  {
    id: 7,
    title: 'Whole body stiffness relief',
    isFavorite: true,
    imgUrl: Exerciseimg3,
    exercises: contentCar.slice(0, 7),
    PATH_IDS: PATH_IDS,
    frequency: { day: 2, week: 2 },
    duration: 20,
    description:
      'Position yourself with feet shoulder-width apart and arms extended out to the sides, parallel to the floor. Position yourself with feet shoulder-width apart and arms extended out to the sides, parallel.',
    isDefault: true,
  },
  {
    id: 8,
    title: 'sl,dfl',
    isFavorite: true,
    imgUrl: Exerciseimg3,
    exercises: contentCar.slice(3, 4),
    PATH_IDS: PATH_IDS_2,
    frequency: { day: 4, week: 5 },
    duration: 20,
    description: 'lorem iasdadasdadsadadasdsadsa',
  },
  {
    id: 9,
    title: 'Upper Body Mobility',
    isFavorite: false,
    imgUrl: Exerciseimg3,
    exercises: contentCar.slice(1, 3),
    PATH_IDS: PATH_IDS,
    frequency: { day: 3, week: 3 },
    duration: 15,
    description: 'Improve upper body flexibility and strength.',
  },
  {
    id: 99,
    title: 'Lower Body Mobility',
    isFavorite: false,
    imgUrl: Exerciseimg3,
    exercises: contentCar.slice(1, 3),
    PATH_IDS: PATH_IDS,
    frequency: { day: 3, week: 3 },
    duration: 15,
    description: 'Improve lower body flexibility and strength.',
  },
];

export const days = Array.from(
  { length: 7 },
  (_, i) =>
    new Date(1970, 0, 4 + i) // Sunday = Jan 4, 1970
      .toLocaleDateString(undefined, { weekday: 'short' })[0]
);

export const TABLE_NAMES = {
  STAFF: 'staff_table',
  PATIENT: 'patient_table',
  STAFF_PATIENTS: 'staff_page_patient_table',
};

export const SORT_ENUM = {
  ASC: 'asc',
  DESC: 'desc',
};

export const TRANSFER_PATIENT_ACTION_TYPE = {
  TRANSFER: 'transfer',
  REMOVE: 'remove',
};

export const PDF_FONT_SIZES = {
  R: 'R', // Regular
  LG: 'LG', // Large
  XL: 'XL', // Extra Large
};

export const EXERCISE_PARAMS_MODES = {
  BASED_ON_REP: 'basedOnRep',
  BASED_ON_TIME: 'basedOnTime',
  SINGLE_REP: 'singleRep',
};

/** Exercise type for prescription API (exercises[].type). Must match backend enum. */
export const EXERCISE_TYPE = {
  BASED_ON_REP: 'BASED_ON_REP',
  BASED_ON_TIME: 'BASED_ON_TIME',
  BASED_ON_SINGLE_REP: 'BASED_ON_SINGLE_REP',
};

/** FT7.5 — how an exercise was performed. Only WITH_MOTION_CAPTURE has a wired data path so far. */
export const EXERCISE_EXECUTION_MODE = {
  MANUAL_CHECK_IN: 'MANUAL_CHECK_IN',
  WITHOUT_MOTION_CAPTURE: 'WITHOUT_MOTION_CAPTURE',
  WITH_MOTION_CAPTURE: 'WITH_MOTION_CAPTURE',
};

export const EXERCISE_LIBRARY_TABS = {
  EXERCISES: 'exercises',
  TEMPLATES: 'templates',
  PRESCRIPTION: 'prescription',
};

export const prescriptionStatuses = {
  NOT_STARTED: 'notStarted',
  INCOMPLETE: 'incomplete',
  COMPLETE: 'complete',
};

export const SORTING_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const AUDIENCE_TYPE = {
  PATIENT: 'patient',
  STAFF: 'staff',
};

export const statusClasses = {
  VERIFIED: 'bg-success text-success',
  NOT_VERIFIED: 'bg-error text-error',
};

export const statusEnum = {
  VERIFIED: 'Verified',
  NOT_VERIFIED: 'Not verified',
};
export const clinicSubscription = {
  PAID: 'Paid',
  EXPIRED: 'Expired',
};
export const clinicSubscriptionClasses = {
  PAID: 'bg-success ',
  EXPIRED: 'bg-error',
};
export const couponStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'In Active',
};
export const couponClasses = {
  ACTIVE: 'bg-success',
  INACTIVE: 'bg-error',
};

export const clinicsOrderableColumns = {
  clinicName: 'Clinic Name',
  accountStatus: 'Account Status',
  subscriptionStatus: 'Subscription Status',
  joinedOn: 'Joined on',
  clinicOwner: 'Clinic Owner',
  // eslint-disable-next-line quotes
  ownerEmail: "Owner's Email",
  // eslint-disable-next-line quotes
  ownerPhone: "Owner's Phone",
  numberOfSeats: 'Num. of Seats',
  lastPayment: 'Last Payment',
  nextPayment: 'Next Payment',
  billingCycle: 'Billing Cycle',
  couponCode: 'Coupon Code',
};
// Mirrors the backend's PERMISSION_SUBJECTS (API_CHANGELOG.md -> Role ->
// permission grid). HEP, THERAPIST and RECEPTIONIST were retired server-side.
export const Resource = {
  CLINIC: 'CLINIC',
  PATIENT: 'PATIENT',
  PRESCRIPTION: 'PRESCRIPTION',
  EXERCISE: 'EXERCISE',
  EXERCISE_FILE: 'EXERCISE_FILE',
  EXERCISE_LIBRARY: 'EXERCISE_LIBRARY',
  TAG: 'TAG',
  TAG_GROUP: 'TAG_GROUP',
  SESSION: 'SESSION',
  APPOINTMENT: 'APPOINTMENT',
  STAFF: 'STAFF',
  VISIT_NOTE: 'VISIT_NOTE',
};

export const Action = {
  CREATE: 'CREATE',
  VIEW: 'VIEW',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  TRANSFER: 'TRANSFER',
  DISCHARGE: 'DISCHARGE',
  READMIT: 'READMIT',
  DEACTIVATE: 'DEACTIVATE',
  RESTORE: 'RESTORE',
};

export const ACCOUNT_STATUS = {
  PENDING: 'PENDING',
  JOINED: 'JOINED',
};

// GET /clinics/users' accountStatus is one of these two enums depending on
// which kind of row it is: the caller's own row (Clinic Owner) uses the raw
// ACCOUNT_STATUS lifecycle above; every other member (Therapist/Receptionist)
// uses this invite-lifecycle status instead.
export const CLINIC_USER_STATUS = {
  INVITED: 'INVITED',
  ACTIVE: 'ACTIVE',
  INVITATION_NOT_DELIVERED: 'INVITATION_NOT_DELIVERED',
  DEACTIVATED: 'DEACTIVATED',
};

export const CLINIC_ADMIN_ACCOUNT_STATUS = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  INVITED: 'INVITED',
};

export const CLINIC_TYPE = {
  SOLO: 'solo',
  ORGANIZATION: 'organization',
};

export const PainLevel = {
  PAIN_FREE: 'PAIN_FREE',
  MILD: 'MILD',
  MODERATE: 'MODERATE',
  SEVERE: 'SEVERE',
  WORST: 'WORST',
};

/** Order matches session modal pain faces: 0=Worst, 1=Severe, 2=Moderate, 3=Mild, 4=Pain free */
export const PAIN_LEVEL_API_ORDER = ['WORST', 'SEVERE', 'MODERATE', 'MILD', 'PAIN_FREE'];

const PAIN_LEVEL_FALLBACK_LABEL = {
  PAIN_FREE: 'Pain free',
  MILD: 'Mild',
  MODERATE: 'Moderate',
  SEVERE: 'Severe',
  WORST: 'Worst',
};

const PAIN_LEVEL_ALIASES = {
  PAINFREE: 'PAIN_FREE',
  'PAIN FREE': 'PAIN_FREE',
};

/** Normalize raw pain level (enum key / label / alias) to a canonical enum key. */
export function normalizePainLevelKey(value) {
  if (typeof value !== 'string') {
    return null;
  }
  const raw = value.trim();
  if (!raw) {
    return null;
  }
  const upper = raw.toUpperCase();
  if (upper in PainLevel) {
    return upper;
  }
  if (upper in PAIN_LEVEL_ALIASES) {
    return PAIN_LEVEL_ALIASES[upper];
  }
  // Accept legacy English labels ("Pain free", etc.).
  const byLabel = Object.entries(PAIN_LEVEL_FALLBACK_LABEL).find(
    ([, label]) => label.toUpperCase() === upper
  );
  return byLabel ? byLabel[0] : null;
}

/** Localized pain level label by raw input; falls back to English label if i18n key is missing. */
export function getPainLevelDisplayLabel(value, t) {
  const key = normalizePainLevelKey(value);
  if (!key) {
    return null;
  }
  if (typeof t === 'function') {
    return t(`common.pain_levels.${key}`, {
      ns: 'patients',
      defaultValue: PAIN_LEVEL_FALLBACK_LABEL[key],
    });
  }
  return PAIN_LEVEL_FALLBACK_LABEL[key];
}

export const SessionCarouselStates = {
  INCOMPLETE_DAY: 'INCOMPLETE_DAY',
  COMPLETE_DAY: 'COMPLETE_DAY',
  COMPLETE_WEEK_FIRST_TIER: 'COMPLETE_WEEK_FIRST_TIER',
  COMPLETE_WEEK_SECOND_TIER: 'COMPLETE_WEEK_SECOND_TIER',
  COMPLETE_WEEK_THIRD_TIER: 'COMPLETE_WEEK_THIRD_TIER',
  COMPLETE_WEEK_FOURTH_TIER: 'COMPLETE_WEEK_FOURTH_TIER',
};

/** Home patient state from get-home-patient API (adherence status) */
export const HOME_PATIENT_STATUS = {
  COMPLETE_WEEK: 'COMPLETE_WEEK',
  COMPLETE_DAY: 'COMPLETE_DAY',
  INCOMPLETE_DAY: 'INCOMPLETE_DAY',
};

/** session.status from GET /home-patient/current */
export const ONLINE_SESSION_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  STARTED: 'STARTED',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
};
export const CALENDAR_STATUS = {
  COMPLETED: 'COMPLETED',
  /** Backend may send this spelling */
  INCOMPLETED: 'INCOMPLETED',
  INCOMPLETE: 'INCOMPLETE',
  EMPTY: 'EMPTY',
};

/**
 * appointments.status code (appointment_statuses lookup table — fixed,
 * operational, not a growable dropdown, so it has no GET endpoint of its own).
 */
export const APPOINTMENT_STATUS = {
  SCHEDULED: 'SCHEDULED',
  CANCELLED: 'CANCELLED',
  NO_SHOW: 'NO_SHOW',
  COMPLETED: 'COMPLETED',
};
